<template>
  <div v-if="showRow" class="mergeLeadRow">
    <div class="mergeLeadRow--heading">
      <p>{{ heading }}</p>
    </div>

    <div class="mergeLeadRow--value">
      <b-radio
        v-if="showRadioInput"
        v-model="selected"
        :native-value="currentValue"
        class="mr-0"
        @input="handleInput"
      >
        <span>{{ (currentLabel) ? currentLabel : currentValue }}</span>
      </b-radio>
      <b-checkbox
        ref="checkbox1"
        v-if="showCheckboxInput"
        v-model="checked1"
        :native-value="currentValue"
        class="mr-0"
        @input="handleInput"
      >
        <span>{{ (currentLabel) ? currentLabel : currentValue }}</span>
      </b-checkbox>

      <p v-if="!showRadioInput && !showCheckboxInput">{{ (currentLabel) ? currentLabel : currentValue }}</p>
    </div>

    <div class="mergeLeadRow--value">
      <b-radio
        v-if="showRadioInput"
        v-model="selected"
        :native-value="duplicateValue"
        class="mr-0"
        @input="handleInput"
      >
        <span>{{ (duplicateLabel) ? duplicateLabel : duplicateValue }}</span>
      </b-radio>
      <b-checkbox
        ref="checkbox2"
        v-if="showCheckboxInput"
        v-model="checked2"
        :native-value="duplicateValue"
        class="mr-0"
        @input="handleInput"
      >
        <span>{{ (duplicateLabel) ? duplicateLabel : duplicateValue }}</span>
      </b-checkbox>

      <p v-if="!showRadioInput && !showCheckboxInput">{{ (duplicateLabel) ? duplicateLabel : duplicateValue }}</p>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "MergeLeadRow",
  props: {
    heading: {
      type: String,
      required: true,
    },
    fieldName: {
      type: String,
      default: null
    },
    currentLabel: {
      type: String,
      default: null
    },
    duplicateLabel: {
      type: String,
      default: null
    },
    currentValue: {
      type: String | Number | null,
      required: true,
    },
    duplicateValue: {
      type: String | Number | null,
      required: true,
    },
    includeRadio: {
      type: Boolean,
      default: false,
    },
    includeCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.currentValue,
      checked1: !!this.currentValue,
      checked2: !!this.duplicateValue,
    }
  },
  created() {
    this.handleInput(this.currentValue)
  },
  computed: {
    showRow() {
      return !!this.currentValue || !!this.duplicateValue;
    },
    showRadioInput() {
      if(!this.includeRadio) return false;

      // If the values are the same then no need to show the radio
      if(this.currentValue === this.duplicateValue) {
        return false;
      }

      // default is to always show
      return true;
    },
    showCheckboxInput() {
      if(!this.includeCheckbox) return false;

      // default is to always show
      return true;
    },
    value1() {
      return this.currentValue ? this.currentValue : '--'
    },
    value2() {
      return this.duplicateValue ? this.duplicateValue : '--'
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', {value: val, field: this.fieldName})
      this.$emit('change', {value: val, field: this.fieldName})
      this.$emit('selected', {value: val, field: this.fieldName})
      this.emitGlobalFieldChangeEvent()
    },
  },
})
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.mergeLeadRow {
  display: flex;
  justify-content: space-between;
  width: 100%;

  &:last-child {

    .mergeLeadRow--value {
      border-bottom: none;
    }
  }

  &--heading {
    width: 26%;
    font-size: 0.875rem;
    padding: 0.75rem 0;
  }

  &--value {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(37% - 24px);
    padding: .75rem .25rem;
    border-bottom: 1px solid $border;
  }
}
</style>
